export default __webpack_public_path__ + "b491704c942d045ad63c5e51279710df.png";